// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/resale/v1/legacy_portal_service.proto (package spwn.resale.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { LegacyPortalResaleServiceGetMyResaleApplicationsRequest, LegacyPortalResaleServiceGetMyResaleApplicationsResponse, LegacyPortalResaleServiceGetMyResaleListingsRequest, LegacyPortalResaleServiceGetMyResaleListingsResponse, LegacyPortalResaleServiceGetResaleRoundsRequest, LegacyPortalResaleServiceGetResaleRoundsResponse, LegacyPortalResaleServiceUpdateResaleApplicationRequest, LegacyPortalResaleServiceUpdateResaleApplicationResponse, LegacyPortalResaleServiceUpdateResaleListingRequest, LegacyPortalResaleServiceUpdateResaleListingResponse } from "./legacy_portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * --- 共通・リセール情報参照 API ---
 *
 * @generated from service spwn.resale.v1.LegacyPortalResaleService
 */
export const LegacyPortalResaleService = {
    typeName: "spwn.resale.v1.LegacyPortalResaleService",
    methods: {
        /**
         * リセール回・受付状況一覧取得 API（イベントページ、出品・申込共通）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.GetResaleRounds
         */
        getResaleRounds: {
            name: "GetResaleRounds",
            I: LegacyPortalResaleServiceGetResaleRoundsRequest,
            O: LegacyPortalResaleServiceGetResaleRoundsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * リセール出品更新 API（出品登録・増減・キャンセルを一括処理）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.UpdateResaleListing
         */
        updateResaleListing: {
            name: "UpdateResaleListing",
            I: LegacyPortalResaleServiceUpdateResaleListingRequest,
            O: LegacyPortalResaleServiceUpdateResaleListingResponse,
            kind: MethodKind.Unary,
        },
        /**
         * 自身の出品状況・一覧取得 API（一覧・詳細兼用）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.GetMyResaleListings
         */
        getMyResaleListings: {
            name: "GetMyResaleListings",
            I: LegacyPortalResaleServiceGetMyResaleListingsRequest,
            O: LegacyPortalResaleServiceGetMyResaleListingsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * 自身の申込状況・一覧取得 API（一覧・詳細兼用）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.GetMyResaleApplications
         */
        getMyResaleApplications: {
            name: "GetMyResaleApplications",
            I: LegacyPortalResaleServiceGetMyResaleApplicationsRequest,
            O: LegacyPortalResaleServiceGetMyResaleApplicationsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * リセール申込更新 API（新規申込・枚数増減・キャンセルを一括処理）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.UpdateResaleApplication
         */
        updateResaleApplication: {
            name: "UpdateResaleApplication",
            I: LegacyPortalResaleServiceUpdateResaleApplicationRequest,
            O: LegacyPortalResaleServiceUpdateResaleApplicationResponse,
            kind: MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map